
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35376',
  depVersions: {
  "documents-public-ui": "static-1.35376",
  "atom": "static-1.5465",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2868",
  "client-types": "static-1.502",
  "cssUtils": "static-1.1007",
  "customer-data-filters-ui": "static-1.41130",
  "customer-data-objects": "static-1.8076",
  "customer-data-property-utils": "static-1.8457",
  "documents-lib": "static-1.35381",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.377",
  "FormsCommonComponents": "static-1.86700",
  "FormUrlGenerator": "static-2.5098",
  "foundations-theming-specialty": "static-1.2579",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5975",
  "hs-test-utils": "static-1.8421",
  "hub-http": "static-1.6596",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12182",
  "HubStyleTokens": "static-2.11875",
  "I18n": "static-7.1688",
  "icons": "static-2.696",
  "jasmine-immutable": "static-1.3371",
  "jasmine-runner": "static-1.6834",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7536",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3275",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5765",
  "quartz": "static-1.7554",
  "react": "static-7.202",
  "react-dlb": "static-1.92",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17112",
  "react-select-plus": "static-1.116",
  "react-utils": "static-2.5606",
  "react-virtualized": "static-2.110",
  "reference-resolvers": "static-1.8567",
  "reference-resolvers-lite": "static-1.8488",
  "reporting-data": "static-1.69061",
  "reporting-reports": "static-1.68737",
  "reporting-snowflake": "static-1.57677",
  "reporting-testing-lib": "static-1.10994",
  "reporting-visualizations": "static-1.61135",
  "reselect": "static-3.15",
  "sales-content-partitioning": "static-1.9324",
  "sanitize": "static-1.4856",
  "sanitize-text": "static-1.8543",
  "SharedI18nStrings": "static-1.186",
  "SharedLegalStrings": "static-1.2115",
  "signup-constants": "static-1.19754",
  "signup-ui-url-generator": "static-2.8443",
  "StyleGuideUI": "static-3.511",
  "superstore": "static-1.5145",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5130",
  "ui-addon-form-validation": "static-1.11334",
  "ui-asset-management-lib": "static-1.11486",
  "ui-images": "static-2.1266",
  "UIComponents": "static-3.8821",
  "usage-tracker": "static-1.7697",
  "usage-tracker-container": "static-1.7687",
  "usage-tracker-core": "static-1.7547",
  "viral-links-lib": "static-1.7460",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10033",
  "foundations-components": "static-1.8612",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1332",
  "quartz-core": "static-1.6773",
  "quick-fetch": "static-1.4175",
  "raven": "static-3.5925",
  "redux": "static-4.81",
  "redux-thunk": "static-2.83",
  "rpc-client-utils": "static-1.5050",
  "ui-addon-i18n": "static-1.11534",
  "ui-addon-upgrades": "static-9.18478",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3831",
  "quartz-webpack": "static-1.3778",
  "foundations-assets": "static-1.5273",
  "foundations-theming": "static-1.4863",
  "hub-http-janus": "static-1.895",
  "hub-http-shared-msw-handlers": "static-1.10749",
  "hubspotter-http": "static-1.4910",
  "sassPrefix": "static-1.274",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.43916",
  "customer-data-filters-ui-msw-helpers": "static-1.23565",
  "customer-data-objects-ui-components": "static-1.13415",
  "customer-data-reference-ui-components": "static-1.13554",
  "customer-data-ui-utilities": "static-1.10217",
  "events-data-lib": "static-1.633",
  "framework-builder-read-service-client": "static-1.4272",
  "hs-resources": "static-1.578",
  "immer": "static-1.104",
  "inbound-db-meta-service-client": "static-1.3724",
  "inbound-db-properties-service-client": "static-1.4095",
  "multi-account-reference-resolvers": "static-1.1389",
  "onboarding-scopes": "static-1.6839",
  "onboarding-tours": "static-1.17253",
  "pulse": "static-1.1018",
  "reporting-datasets-permissions-lib": "static-1.14601",
  "segments-client-types": "static-1.11839",
  "stylex": "static-1.45",
  "trellis-assets": "static-1.2863",
  "trellis-components": "static-1.2882",
  "trellis-theming": "static-1.1362",
  "ui-addon-teams": "static-1.21968",
  "quartz-auth": "static-1.1229",
  "ui-business-units-lib": "static-1.9478",
  "usage-tracker-session-replay": "static-1.5383",
  "ai-components-ui-library": "static-1.9869",
  "ContentUtils": "static-1.69285",
  "customer-data-properties": "static-1.52808",
  "forms-ai-lib": "static-1.4862",
  "forms-utils-lib": "static-1.13199",
  "foundations-components-test-utils": "static-1.6095",
  "react-dnd-compat": "static-1.4999",
  "react-tinymce": "static-1.56117",
  "tinymce-config": "static-2.55243",
  "ui-gdpr-components": "static-1.10648",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3848",
  "HeadJS": "static-2.809",
  "framer-motion": "static-1.82",
  "hs-test-utils-bend-plugin": "static-1.3532",
  "msw": "static-1.39",
  "msw-config": "static-1.14",
  "testing-library": "static-1.162",
  "hs-locale-management": "static-1.347",
  "ui-fonts": "static-1.1137",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4695",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1219",
  "web-vitals": "static-1.18",
  "batch-promise": "static-1.1931",
  "external-options-client-types": "static-1.4393",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7281",
  "quartz-i18n": "static-1.1229",
  "frontend-preferences-client": "static-1.8306",
  "graphql": "static-1.92",
  "persist-promise": "static-1.4088",
  "reporting-client-types": "static-1.2757",
  "apollo-stack-hubspot": "static-3.97",
  "growth-payments-core": "static-1.26333",
  "hubspot-apollo-client": "static-1.5260",
  "foundations-components-legacy": "static-1.1637",
  "quartz-routing": "static-1.984",
  "hs-story-utils": "static-1.9809",
  "react-flip-move": "static-1.81",
  "nested-table": "static-1.621",
  "seat-types-lib": "static-1.877",
  "timezone-utils": "static-2.5616",
  "react-create-root-preference": "static-1.86",
  "bend-plugin-foundations-components": "static-1.4881",
  "floating-ui": "static-1.66",
  "react-aria": "static-1.75",
  "tanstack-table": "static-1.64",
  "opentelemetry-fe-types": "static-1.171",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.590",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.546",
  "quartz-test": "static-1.1229",
  "quartz-tracking": "static-1.933",
  "bend-plugin-chirp-manifest": "static-1.460",
  "chirp-fetch": "static-1.2285",
  "merchandise-lib": "static-1.282",
  "purchase-motions-components": "static-1.6524",
  "ts-schema": "static-1.4345",
  "bender-build-tools": "static-1.3452",
  "bend-plugin-foundations-theming": "static-1.3346",
  "restore-request-side-panel-lib": "static-1.1839",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5013",
  "conditional-properties-service-client": "static-1.4068",
  "crm-pipelines-api-client-types": "static-1.4398",
  "event-emitter": "static-1.1345",
  "fdsr-migration-layer": "static-1.400",
  "multi-currency-client-types": "static-1.3962",
  "getting-started-shared-tasks": "static-1.19392",
  "growth-data-modal": "static-1.6002",
  "growth-onboarding-confetti": "static-1.3450",
  "growth-onboarding-next-action-utils": "static-1.2828",
  "navigation-components": "static-1.18973",
  "onboarding-tours-client": "static-1.5468",
  "onboarding-tours-utils": "static-1.1320",
  "ui-shepherd-react": "static-3.10656",
  "ui-shepherd-tracker": "static-1.8037",
  "ui-universal-auth": "static-1.9555",
  "user-context": "static-1.5473",
  "bend-plugin-pulse": "static-1.521",
  "fast-json-patch": "static-1.73",
  "crm-index-associations-lib": "static-1.6831",
  "stylex-utils": "static-1.155",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "tanstack-virtual": "static-1.41",
  "hubspotter-http-shared-msw-handlers": "static-1.10747",
  "magpie-lib": "static-1.5823",
  "navigation-messaging": "static-1.8300",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23360",
  "copilot-toolkit": "static-1.11982",
  "cms-field-types": "static-1.5197",
  "content-icons-ui": "static-1.2412",
  "integrations-lib": "static-1.17227",
  "calling-global-api": "static-1.65874",
  "calling-internal-common": "static-1.31707",
  "calling-lifecycle-internal": "static-1.67256",
  "calling-lifecycle-messages": "static-1.59549",
  "commerce-products-lib": "static-1.10696",
  "crm-index-visualization-core": "static-1.4638",
  "crm-links": "static-1.6686",
  "customer-data-properties-shared-msw-handlers": "static-1.10076",
  "file-manager-components": "static-1.24661",
  "formula-editor": "static-1.14887",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4476",
  "meetings-icalendar-utils-lib": "static-1.1021",
  "object-builder-ui-client": "static-1.49845",
  "pipeline-validation-client-types": "static-1.4234",
  "property-value-citations": "static-1.3422",
  "smart-data-capture-core": "static-1.272",
  "smart-property-lib": "static-1.8460",
  "tiered-pricing": "static-1.2084",
  "topics-actions-lib": "static-1.558",
  "trial-components-library": "static-1.14236",
  "ui-addon-iframeable": "static-1.9463",
  "zustand": "static-1.86",
  "final-form": "static-1.81",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.81",
  "rich-text-lib": "static-1.20422",
  "tinymce-themes": "static-1.57213",
  "data-token-picker": "static-1.16997",
  "hub-http-contrib": "static-1.3412",
  "interframe": "static-3.5127",
  "tinymce-data": "static-1.41328",
  "tinymce-plugins": "static-1.58357",
  "ui-addon-sales-email": "static-1.5588",
  "framework-data-schema-quick-fetch": "static-1.7186",
  "ui-addon-opt": "static-4.8745",
  "hubspot-apollo-cache": "static-1.719",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.531",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.90",
  "purchase-motions-api": "static-1.6527",
  "onboarding-data-sync-lib": "static-1.2674",
  "growth-onboarding-next-action-components": "static-1.2856",
  "user-context-client": "static-1.4894",
  "idb-keyval": "static-1.54",
  "magpie-types": "static-1.5283",
  "nest": "static-1.620",
  "reactive-lib": "static-1.1107",
  "simple-logging-lib": "static-1.3438",
  "unified-auth-core-lib": "static-1.1351",
  "getting-started-shared-tasks-store": "static-1.18510",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1936",
  "integrations-error-boundary-lib": "static-1.14642",
  "integrations-tracking-lib": "static-1.5996",
  "native-integrations-shared-strings": "static-1.8150",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10756",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1069",
  "calling-error-reporting": "static-1.31714",
  "shared-worker-versioning": "static-1.11425",
  "calling-usage-tracker": "static-1.6921",
  "voice-sms-access-library": "static-1.2238",
  "customer-data-tracking": "static-1.7258",
  "commerce-permissions": "static-1.1161",
  "products-iframe-lib": "static-1.8723",
  "products-ui-components-shared-msw-handlers": "static-1.11131",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10832",
  "sales-views-client-types": "static-1.4643",
  "location-customization-utils-lib": "static-1.10251",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4530",
  "poll-commands": "static-1.3857",
  "video-components-external": "static-1.12281",
  "video-data-lib": "static-1.35939",
  "bark-lib": "static-1.16914",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6274",
  "react-codemirror": "static-1.11026",
  "data-agent-kit": "static-1.758",
  "feedback-loader": "static-1.29920",
  "fsm": "static-1.4138",
  "policy-lib": "static-1.7192",
  "react-colorpicker": "static-2.10598",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10895",
  "embedded-academy-lib": "static-1.15735",
  "hubs-service-types": "static-1.1648",
  "nudge-client-utils": "static-1.3263",
  "salesImages": "static-1.647",
  "FileManagerLib": "static-1.40301",
  "NamespacedHubStyle": "static-2.9311",
  "FileManagerCore": "static-1.40160",
  "content-assistance-lib": "static-1.8302",
  "layout-dnd-components": "static-1.13082",
  "layout-dnd-utils": "static-1.12057",
  "ui-addon-emoji-picker": "static-1.10254",
  "ui-brand-identity-lib": "static-1.16724",
  "InboxConnectUtils": "static-4.15691",
  "meetings-connect-utils-lib": "static-1.7999",
  "breeze-engine-chat-components": "static-1.914",
  "breeze-engine-core": "static-1.1214",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "universal-page-editor-lib": "static-1.3395",
  "adobe-sign-auth-lib": "static-1.609",
  "ads-unified-auth-lib": "static-1.1645",
  "custom-vendor-connection-lib": "static-1.119",
  "google-sheets-integration-lib": "static-1.1172",
  "microsoft-drive-auth-lib": "static-1.324",
  "surveymonkey-integration-lib": "static-1.667",
  "slack-ui-library": "static-1.10783",
  "calling-orchestration-schema": "static-1.37015",
  "crm-record-cards-service-types": "static-1.3821",
  "content-media-composition-data-lib": "static-1.13408",
  "content-media-compositions": "static-2.17415",
  "media-bridge-lib": "static-1.19513",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16500",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4891",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15195",
  "nudge-custom-function-registry": "static-1.3020",
  "nudge-renderer-utils": "static-1.3339",
  "whisper-core-api": "static-1.7475",
  "audio-components": "static-1.6449",
  "FileManagerImages": "static-1.37812",
  "video-components": "static-1.14283",
  "breeze-artifacts-sdk": "static-1.587",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4903",
  "video-embed": "static-1.36773",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29447",
  "ContentData": "static-1.69360",
  "layout-data-lib": "static-1.10382",
  "academy-service-client": "static-1.4078",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4780",
  "trellis-ecosystem": "static-1.7729",
  "ui-addon-react-router-dom": "static-1.9915",
  "wootric-nps": "static-1.7248",
  "social-insights-client-types": "static-1.22773",
  "outpost": "static-1.4523",
  "growth-onboarding-feedback-components": "static-1.6970",
  "advanced-menus-core": "static-1.15680",
  "advanced-menus-lib": "static-1.12508",
  "ExportDialog": "static-6.10763",
  "ui-memberships-settings-lib": "static-1.34979",
  "marketplace-ui-apps-core": "static-1.19423",
  "marketplace-ui-common": "static-1.20891",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15679",
  "simple-menus-lib": "static-1.17196",
  "settings-ui-lib": "static-1.12910",
  "developer-experience-shared-components": "static-1.10921",
  "immutable-less": "static-1.5036",
  "marketplace-ui-client-types": "static-1.18298",
  "ui-addon-integrations-directory-panel": "static-2.8383",
  "ui-extensibility-client-types": "static-1.4302",
  "ai-settings-ui-library": "static-1.8448",
  "nav-meta": "static-1.30610",
  "ui-product-approvals-common": "static-1.1316",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "simple-data-table": "static-1.3650"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35376",
  "atom": "/atom/static-1.5465",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2868",
  "client-types": "/client-types/static-1.502",
  "cssUtils": "/cssUtils/static-1.1007",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41130",
  "customer-data-objects": "/customer-data-objects/static-1.8076",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8457",
  "documents-lib": "/documents-lib/static-1.35381",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.377",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86700",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5098",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2579",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5975",
  "hs-test-utils": "/hs-test-utils/static-1.8421",
  "hub-http": "/hub-http/static-1.6596",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12182",
  "HubStyleTokens": "/HubStyleTokens/static-2.11875",
  "I18n": "/I18n/static-7.1688",
  "icons": "/icons/static-2.696",
  "jasmine-immutable": "/jasmine-immutable/static-1.3371",
  "jasmine-runner": "/jasmine-runner/static-1.6834",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7536",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3275",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5765",
  "quartz": "/quartz/static-1.7554",
  "react": "/react/static-7.202",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17112",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-utils": "/react-utils/static-2.5606",
  "react-virtualized": "/react-virtualized/static-2.110",
  "reference-resolvers": "/reference-resolvers/static-1.8567",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8488",
  "reporting-data": "/reporting-data/static-1.69061",
  "reporting-reports": "/reporting-reports/static-1.68737",
  "reporting-snowflake": "/reporting-snowflake/static-1.57677",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10994",
  "reporting-visualizations": "/reporting-visualizations/static-1.61135",
  "reselect": "/reselect/static-3.15",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9324",
  "sanitize": "/sanitize/static-1.4856",
  "sanitize-text": "/sanitize-text/static-1.8543",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2115",
  "signup-constants": "/signup-constants/static-1.19754",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8443",
  "StyleGuideUI": "/StyleGuideUI/static-3.511",
  "superstore": "/superstore/static-1.5145",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5130",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11334",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11486",
  "ui-images": "/ui-images/static-2.1266",
  "UIComponents": "/UIComponents/static-3.8821",
  "usage-tracker": "/usage-tracker/static-1.7697",
  "usage-tracker-container": "/usage-tracker-container/static-1.7687",
  "usage-tracker-core": "/usage-tracker-core/static-1.7547",
  "viral-links-lib": "/viral-links-lib/static-1.7460",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10033",
  "foundations-components": "/foundations-components/static-1.8612",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1332",
  "quartz-core": "/quartz-core/static-1.6773",
  "quick-fetch": "/quick-fetch/static-1.4175",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.83",
  "rpc-client-utils": "/rpc-client-utils/static-1.5050",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11534",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18478",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3831",
  "quartz-webpack": "/quartz-webpack/static-1.3778",
  "foundations-assets": "/foundations-assets/static-1.5273",
  "foundations-theming": "/foundations-theming/static-1.4863",
  "hub-http-janus": "/hub-http-janus/static-1.895",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10749",
  "hubspotter-http": "/hubspotter-http/static-1.4910",
  "sassPrefix": "/sassPrefix/static-1.274",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.43916",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23565",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13415",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13554",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10217",
  "events-data-lib": "/events-data-lib/static-1.633",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4272",
  "hs-resources": "/hs-resources/static-1.578",
  "immer": "/immer/static-1.104",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3724",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4095",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1389",
  "onboarding-scopes": "/onboarding-scopes/static-1.6839",
  "onboarding-tours": "/onboarding-tours/static-1.17253",
  "pulse": "/pulse/static-1.1018",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14601",
  "segments-client-types": "/segments-client-types/static-1.11839",
  "stylex": "/stylex/static-1.45",
  "trellis-assets": "/trellis-assets/static-1.2863",
  "trellis-components": "/trellis-components/static-1.2882",
  "trellis-theming": "/trellis-theming/static-1.1362",
  "ui-addon-teams": "/ui-addon-teams/static-1.21968",
  "quartz-auth": "/quartz-auth/static-1.1229",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9478",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5383",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9869",
  "ContentUtils": "/ContentUtils/static-1.69285",
  "customer-data-properties": "/customer-data-properties/static-1.52808",
  "forms-ai-lib": "/forms-ai-lib/static-1.4862",
  "forms-utils-lib": "/forms-utils-lib/static-1.13199",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6095",
  "react-dnd-compat": "/react-dnd-compat/static-1.4999",
  "react-tinymce": "/react-tinymce/static-1.56117",
  "tinymce-config": "/tinymce-config/static-2.55243",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10648",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3848",
  "HeadJS": "/HeadJS/static-2.809",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3532",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.14",
  "testing-library": "/testing-library/static-1.162",
  "hs-locale-management": "/hs-locale-management/static-1.347",
  "ui-fonts": "/ui-fonts/static-1.1137",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4695",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1219",
  "web-vitals": "/web-vitals/static-1.18",
  "batch-promise": "/batch-promise/static-1.1931",
  "external-options-client-types": "/external-options-client-types/static-1.4393",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7281",
  "quartz-i18n": "/quartz-i18n/static-1.1229",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8306",
  "graphql": "/graphql/static-1.92",
  "persist-promise": "/persist-promise/static-1.4088",
  "reporting-client-types": "/reporting-client-types/static-1.2757",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.97",
  "growth-payments-core": "/growth-payments-core/static-1.26333",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5260",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1637",
  "quartz-routing": "/quartz-routing/static-1.984",
  "hs-story-utils": "/hs-story-utils/static-1.9809",
  "react-flip-move": "/react-flip-move/static-1.81",
  "nested-table": "/nested-table/static-1.621",
  "seat-types-lib": "/seat-types-lib/static-1.877",
  "timezone-utils": "/timezone-utils/static-2.5616",
  "react-create-root-preference": "/react-create-root-preference/static-1.86",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4881",
  "floating-ui": "/floating-ui/static-1.66",
  "react-aria": "/react-aria/static-1.75",
  "tanstack-table": "/tanstack-table/static-1.64",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.171",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.590",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.546",
  "quartz-test": "/quartz-test/static-1.1229",
  "quartz-tracking": "/quartz-tracking/static-1.933",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.460",
  "chirp-fetch": "/chirp-fetch/static-1.2285",
  "merchandise-lib": "/merchandise-lib/static-1.282",
  "purchase-motions-components": "/purchase-motions-components/static-1.6524",
  "ts-schema": "/ts-schema/static-1.4345",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3346",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1839",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5013",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4068",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4398",
  "event-emitter": "/event-emitter/static-1.1345",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.400",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3962",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19392",
  "growth-data-modal": "/growth-data-modal/static-1.6002",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3450",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2828",
  "navigation-components": "/navigation-components/static-1.18973",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5468",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1320",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10656",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8037",
  "ui-universal-auth": "/ui-universal-auth/static-1.9555",
  "user-context": "/user-context/static-1.5473",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.521",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6831",
  "stylex-utils": "/stylex-utils/static-1.155",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10747",
  "magpie-lib": "/magpie-lib/static-1.5823",
  "navigation-messaging": "/navigation-messaging/static-1.8300",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23360",
  "copilot-toolkit": "/copilot-toolkit/static-1.11982",
  "cms-field-types": "/cms-field-types/static-1.5197",
  "content-icons-ui": "/content-icons-ui/static-1.2412",
  "integrations-lib": "/integrations-lib/static-1.17227",
  "calling-global-api": "/calling-global-api/static-1.65874",
  "calling-internal-common": "/calling-internal-common/static-1.31707",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67256",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59549",
  "commerce-products-lib": "/commerce-products-lib/static-1.10696",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4638",
  "crm-links": "/crm-links/static-1.6686",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10076",
  "file-manager-components": "/file-manager-components/static-1.24661",
  "formula-editor": "/formula-editor/static-1.14887",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4476",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1021",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49845",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4234",
  "property-value-citations": "/property-value-citations/static-1.3422",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.272",
  "smart-property-lib": "/smart-property-lib/static-1.8460",
  "tiered-pricing": "/tiered-pricing/static-1.2084",
  "topics-actions-lib": "/topics-actions-lib/static-1.558",
  "trial-components-library": "/trial-components-library/static-1.14236",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9463",
  "zustand": "/zustand/static-1.86",
  "final-form": "/final-form/static-1.81",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "rich-text-lib": "/rich-text-lib/static-1.20422",
  "tinymce-themes": "/tinymce-themes/static-1.57213",
  "data-token-picker": "/data-token-picker/static-1.16997",
  "hub-http-contrib": "/hub-http-contrib/static-1.3412",
  "interframe": "/interframe/static-3.5127",
  "tinymce-data": "/tinymce-data/static-1.41328",
  "tinymce-plugins": "/tinymce-plugins/static-1.58357",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5588",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7186",
  "ui-addon-opt": "/ui-addon-opt/static-4.8745",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.719",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.531",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.90",
  "purchase-motions-api": "/purchase-motions-api/static-1.6527",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2674",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2856",
  "user-context-client": "/user-context-client/static-1.4894",
  "idb-keyval": "/idb-keyval/static-1.54",
  "magpie-types": "/magpie-types/static-1.5283",
  "nest": "/nest/static-1.620",
  "reactive-lib": "/reactive-lib/static-1.1107",
  "simple-logging-lib": "/simple-logging-lib/static-1.3438",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1351",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18510",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1936",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14642",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5996",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8150",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10756",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1069",
  "calling-error-reporting": "/calling-error-reporting/static-1.31714",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11425",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6921",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2238",
  "customer-data-tracking": "/customer-data-tracking/static-1.7258",
  "commerce-permissions": "/commerce-permissions/static-1.1161",
  "products-iframe-lib": "/products-iframe-lib/static-1.8723",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11131",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10832",
  "sales-views-client-types": "/sales-views-client-types/static-1.4643",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10251",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4530",
  "poll-commands": "/poll-commands/static-1.3857",
  "video-components-external": "/video-components-external/static-1.12281",
  "video-data-lib": "/video-data-lib/static-1.35939",
  "bark-lib": "/bark-lib/static-1.16914",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6274",
  "react-codemirror": "/react-codemirror/static-1.11026",
  "data-agent-kit": "/data-agent-kit/static-1.758",
  "feedback-loader": "/feedback-loader/static-1.29920",
  "fsm": "/fsm/static-1.4138",
  "policy-lib": "/policy-lib/static-1.7192",
  "react-colorpicker": "/react-colorpicker/static-2.10598",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10895",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15735",
  "hubs-service-types": "/hubs-service-types/static-1.1648",
  "nudge-client-utils": "/nudge-client-utils/static-1.3263",
  "salesImages": "/salesImages/static-1.647",
  "FileManagerLib": "/FileManagerLib/static-1.40301",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9311",
  "FileManagerCore": "/FileManagerCore/static-1.40160",
  "content-assistance-lib": "/content-assistance-lib/static-1.8302",
  "layout-dnd-components": "/layout-dnd-components/static-1.13082",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12057",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10254",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16724",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15691",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7999",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.914",
  "breeze-engine-core": "/breeze-engine-core/static-1.1214",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3395",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.609",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1645",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.119",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1172",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.324",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.667",
  "slack-ui-library": "/slack-ui-library/static-1.10783",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37015",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3821",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13408",
  "content-media-compositions": "/content-media-compositions/static-2.17415",
  "media-bridge-lib": "/media-bridge-lib/static-1.19513",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16500",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4891",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15195",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3020",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3339",
  "whisper-core-api": "/whisper-core-api/static-1.7475",
  "audio-components": "/audio-components/static-1.6449",
  "FileManagerImages": "/FileManagerImages/static-1.37812",
  "video-components": "/video-components/static-1.14283",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.587",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4903",
  "video-embed": "/video-embed/static-1.36773",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29447",
  "ContentData": "/ContentData/static-1.69360",
  "layout-data-lib": "/layout-data-lib/static-1.10382",
  "academy-service-client": "/academy-service-client/static-1.4078",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4780",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7729",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9915",
  "wootric-nps": "/wootric-nps/static-1.7248",
  "social-insights-client-types": "/social-insights-client-types/static-1.22773",
  "outpost": "/outpost/static-1.4523",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6970",
  "advanced-menus-core": "/advanced-menus-core/static-1.15680",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12508",
  "ExportDialog": "/ExportDialog/static-6.10763",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34979",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19423",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20891",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15679",
  "simple-menus-lib": "/simple-menus-lib/static-1.17196",
  "settings-ui-lib": "/settings-ui-lib/static-1.12910",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10921",
  "immutable-less": "/immutable-less/static-1.5036",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18298",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8383",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4302",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8448",
  "nav-meta": "/nav-meta/static-1.30610",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1316",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "simple-data-table": "/simple-data-table/static-1.3650"
}
};
